import React from 'react';
import PropTypes from 'prop-types';

/**
 * Stateless component to display file when added with a button to remove it if needed
 */
export const FileComponent = ({ file, onRemoveFile }) => {
    const onButtonRemoveClick = event => {
        event.preventDefault();
        onRemoveFile(file);
    };
    return (
        <li className="file flex-container-h flex-center-alt">
            {file.name}
            <button onClick={onButtonRemoveClick}>X</button>
        </li>
    );
};

class FileListComponent extends React.Component {
    render() {
        const { files, onRemoveFile } = this.props;
        if (files.length) {
            return (
                <ul className="files flex-container-h flex-center-alt">
                    {files.map((file, index) => (
                        <FileComponent key={index} file={file} onRemoveFile={onRemoveFile} />
                    ))}
                </ul>
            );
        } else {
            return null;
        }
    }
}

FileListComponent.propTypes = {
    files: PropTypes.array.isRequired,
    onRemoveFile: PropTypes.func.isRequired
};

export default FileListComponent;



// WEBPACK FOOTER //
// ./src/components/form/fileInput/FileListComponent.js